// extracted by mini-css-extract-plugin
export var colorSquare = "_rq-0";
export var danger = "_rq-5";
export var lightPink = "_rq-8";
export var neutralBlue = "_rq-7";
export var neutralYellow = "_rq-6";
export var normal = "_rq-1";
export var primary = "_rq-2";
export var primaryLight = "_rq-3";
export var solidBlack = "_rq-g";
export var solidGreen = "_rq-b";
export var solidLightBlue = "_rq-d";
export var solidNavy = "_rq-c";
export var solidOrange = "_rq-f";
export var solidPink = "_rq-e";
export var solidRed = "_rq-9";
export var solidYellow = "_rq-a";
export var success = "_rq-4";